import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

const RoleSchema = z.object({
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime().optional(),
    name: z.string(),
    description: z.string(),
});

export type TRole = z.infer<typeof RoleSchema>;

const UserSchema = z.object({
    email: z.string().email(),
    phone_number: z.string(),
    role_id: z.string(),
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime().optional(),
    status: z.string().optional(),
    name: z.string().nullable().optional(),
    role: RoleSchema,
});
export type TUser = z.infer<typeof UserSchema>;

export const ResponseGetUsersSchema = z.object({
    data: z.array(UserSchema),
    pagination: PaginationResponseSchema,
    message: z.string(),
    statusCode: z.number(),
});

export type User = z.infer<typeof ResponseGetUsersSchema>;
export type TUserListResponse = z.infer<typeof ResponseGetUsersSchema>;
